import { ValueOf } from '../../../../utilities/types';

const forcedEnrollmentSteps = {
  STARTING: 'starting',
  PAIR: 'pair',
  RECOVERY_CODES: 'recovery-codes',
  FAILED: 'failed',
} as const;

export type ForcedEnrollmentStep = ValueOf<typeof forcedEnrollmentSteps>;

export const deriveForcedEnrollmentStep = ({
  hasRecoveryCodes,
  hasPendingEnrollment,
  startFailed,
}: {
  hasRecoveryCodes: boolean;
  hasPendingEnrollment: boolean;
  startFailed: boolean;
}): ForcedEnrollmentStep => {
  if (hasRecoveryCodes) return forcedEnrollmentSteps.RECOVERY_CODES;
  if (hasPendingEnrollment) return forcedEnrollmentSteps.PAIR;
  if (startFailed) return forcedEnrollmentSteps.FAILED;
  return forcedEnrollmentSteps.STARTING;
};

export default forcedEnrollmentSteps;
